import Style from "./css/style.module.css";
import BoxTempleteArea from "./templete/box";
import LineTempleteArea from "./templete/line";
import glowple_500 from "@/img/logo/glowple_500.png";

function PrintOnePageArea(props: any) {
  let myProps = {
    todo_info: {},
    print_options: {},
    total_page_num: 0,
    now_page_num: 0,
    word_arr: [],
    row_cnt: 0,
    col_cnt: 0,
    ...props
  };
  let todo_info = myProps.todo_info || {};
  let print_options = myProps.print_options || {};
  let total_page_num = myProps.total_page_num || 0;
  let now_page_num = myProps.now_page_num || 0;
  let word_arr = myProps.word_arr || [];

  let title_str = "";
  let select_date = "";
  let stu_name = "";
  let comp_name = "";
  let row_cnt = myProps.row_cnt || 0;
  let col_cnt = myProps.col_cnt || 0;
  
  let logo_url = glowple_500;
  if(print_options.user&&print_options.user.comp_sort_detail=="sntbr"){
    logo_url = process.env.REACT_APP_API_URL+"/img/logo/sntb_logo_400.png";
  }
  if (todo_info) {
    title_str = todo_info.a_title;
    select_date = todo_info.a_reserve_start_date.substring(0, 10);
    comp_name = todo_info.main_comp_title;
    if(print_options.is_print_stu_name){
      stu_name = todo_info.a_stu_name;
    }
  }
  if(print_options.user&&print_options.user.logo_url){
    logo_url=print_options.user.logo_url;
  }
  let templete_data_json={
    title_str:title_str,
    select_date:select_date,
    stu_name:stu_name,
    comp_name:comp_name,
    row_cnt:row_cnt,
    col_cnt:col_cnt,
    repeat_cnt:print_options.repeat_cnt,
    word_arr:word_arr,
    total_page_num:total_page_num,
    now_page_num:now_page_num,
    logo_url:logo_url,
    is_print_word:print_options.is_print_word,
    is_print_mean:print_options.is_print_mean
  };

  return (
    <div className="a4page" style={{position:"relative"}} >
      {print_options.print_templete == "box" &&
        <BoxTempleteArea
          Style={Style}
          templete_data_json={templete_data_json}
        ></BoxTempleteArea>
      }
      {print_options.print_templete == "line" &&
        <LineTempleteArea
          Style={Style}
          templete_data_json={templete_data_json}
        ></LineTempleteArea>
      }
    </div>
  );
};
export default PrintOnePageArea;